var _path, _path2, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuggestionLoaderBlue3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 16,
    viewBox: "0 0 40 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M4.45784 1.89163C4.4048 1.5696 4.12641 1.33331 3.80004 1.33331C3.47367 1.33331 3.19528 1.5696 3.14224 1.89163C3.07558 2.29634 2.92918 2.56771 2.74371 2.75138C2.55758 2.9357 2.28606 3.07722 1.89169 3.14218C1.56966 3.19522 1.33337 3.47361 1.33337 3.79998C1.33337 4.12635 1.56966 4.40474 1.89169 4.45778C2.2964 4.52445 2.56778 4.67084 2.75144 4.85631C2.93576 5.04244 3.07728 5.31396 3.14224 5.70833C3.19528 6.03036 3.47367 6.26665 3.80004 6.26665C4.12641 6.26665 4.4048 6.03036 4.45784 5.70833C4.5228 5.31396 4.66432 5.04244 4.84864 4.85631C5.03231 4.67084 5.30368 4.52445 5.70839 4.45778C6.03042 4.40474 6.26671 4.12635 6.26671 3.79998C6.26671 3.47361 6.03042 3.19522 5.70839 3.14218C5.30368 3.07551 5.03231 2.92912 4.84864 2.74365C4.66432 2.55752 4.5228 2.286 4.45784 1.89163Z",
    fill: "#0086C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26122 1.91592C9.21889 1.58291 8.93556 1.33331 8.59987 1.33331C8.26418 1.33331 7.98085 1.58291 7.93852 1.91592C7.7238 3.60537 7.26793 4.82305 6.52633 5.67748C5.79472 6.52042 4.71734 7.08705 3.09653 7.34137C2.7722 7.39226 2.5332 7.67169 2.5332 7.99998C2.5332 8.32827 2.7722 8.6077 3.09653 8.65859C4.71734 8.91291 5.79472 9.47954 6.52633 10.3225C7.26793 11.1769 7.7238 12.3946 7.93852 14.084C7.98085 14.417 8.26418 14.6666 8.59987 14.6666C8.93556 14.6666 9.21889 14.417 9.26122 14.084C9.47594 12.3946 9.93181 11.1769 10.6734 10.3225C11.405 9.47954 12.4824 8.91291 14.1032 8.65859C14.4275 8.6077 14.6665 8.32827 14.6665 7.99998C14.6665 7.67169 14.4275 7.39226 14.1032 7.34137C12.3943 7.07323 11.3157 6.47078 10.6046 5.6177C9.88047 4.74894 9.46731 3.5375 9.26122 1.91592Z",
    fill: "#0086C9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 8,
    r: 2,
    fill: "#66B8E0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 8,
    r: 2,
    fill: "#B3DBF0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 6,
    r: 2,
    fill: "#E6F4FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggestionLoaderBlue3);
export default __webpack_public_path__ + "static/media/suggestion-loader-blue-3.f64c757fdecb145137d6ed496419db11.svg";
export { ForwardRef as ReactComponent };